import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import {
    parameterizablePasswordOrAKVtoSecretBase,
    parameterizableSecretBaseToModel
} from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';
import { SalesforceLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceLinkedService),
    disabled: __IS_FABRIC_DPE__,
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                environmentUrl: '*',
                username: '*',
                password: 'secret',
                securityToken: 'secret',
                apiVersion: '*',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class SalesforceLinkedServiceAdapter extends LinkedServiceAdapter<SalesforceLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => SalesforceLinkedService {
        return SalesforceLinkedService;
    }

    protected model(): IModel {
        return SalesforceLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SalesforceLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SalesforceLinkedService;

        const environmentUrl = this.valueToResource(linkedService, SalesforceLinkedService.ENVIRONMENT_URL);
        const apiVersion = !stringIsNullOrEmpty(this.valueToResource(linkedService, SalesforceLinkedService.API_VERSION)) && linkedService.apiVersion !== 'Default'
            ? this.valueToResource(linkedService, SalesforceLinkedService.API_VERSION)
            : undefined;
        const securityToken = parameterizablePasswordOrAKVtoSecretBase(linkedService, SalesforceLinkedService.SECURITY_TOKEN, this.context);
        const username = this.valueToResource(linkedService, SalesforceLinkedService.USER_NAME);
        const password = parameterizablePasswordOrAKVtoSecretBase(linkedService, SalesforceLinkedService.PASSWORD, this.context);

        properties.type = Metamodel.modelOf(linkedService).name;
        properties.typeProperties = {
            environmentUrl,
            username,
            password,
            securityToken,
            apiVersion
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: SalesforceLinkedService): Promise<SalesforceLinkedService> {
        const properties = linkedServiceResource.properties as Model.SalesforceLinkedService;
        const typeProperties = properties.typeProperties;
        ValueAdapter.toModel(
            linkedService,
            SalesforceLinkedService.ENVIRONMENT_URL,
            typeProperties.environmentUrl
                ? isLogicAppExpression(typeProperties.environmentUrl) || typeof typeProperties.environmentUrl !== 'string'
                    ? typeProperties.environmentUrl
                    : typeProperties.environmentUrl.toLowerCase()
                : 'https://login.salesforce.com'
        );
        parameterizableSecretBaseToModel(linkedService, SalesforceLinkedService.SECURITY_TOKEN, typeProperties.securityToken, this.context);
        ValueAdapter.toModel(linkedService, SalesforceLinkedService.API_VERSION, typeProperties.apiVersion != null ? typeProperties.apiVersion : 'Default');

        ValueAdapter.toModel(linkedService, SalesforceLinkedService.USER_NAME, typeProperties.username);
        parameterizableSecretBaseToModel(linkedService, SalesforceLinkedService.PASSWORD, typeProperties.password, this.context);

        return linkedService;
    }
}
